import React from "react";
import styled from "styled-components/macro";

export default function CommentsBar({ children }) {
  // if no children, return null
  if (!children[0] && children[1].length === 0) return null;

  return <CommentsBarWrapper className="CommentsBar">{children}</CommentsBarWrapper>;
}

const CommentsBarWrapper = styled.div`
  box-sizing: border-box;
  position: relative;
  flex-grow: 0;
  flex-basis: 270px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
